import { buildQueryVariables } from '../../helpers';

/**
 * @param {{
 *   OrderService: ReturnType<import('../../services/OrderService').default>,
 *   OrderItemGroupService: ReturnType<import('../../services/OrderItemGroupService').default>,
 *   OrderItemService: ReturnType<import('../../services/OrderItemService').default>,
 *   OrderItemStatusService: ReturnType<import('../../services/OrderItemStatusService').default>,
 * }} param0
 */
export default function orderUseCase({
  OrderService,
  OrderItemGroupService,
  OrderItemService,
  OrderItemStatusService,
}) {
  const getOrders = (variables) => {
    const orderVariables = buildQueryVariables(variables);
    return OrderService.getOrders(orderVariables);
  };
  const getOrdersByAdmin = (variables) => {
    const orderVariables = buildQueryVariables(variables);
    return OrderService.getOrdersByAdmin(orderVariables);
  };

  const getOrderById = (id) => OrderService.getOrderById(id);

  const getOrderItems = (input) => OrderService.getOrderItems(input);
  const getOrderItemsByAdmin = (input) => OrderService.getOrderItemsByAdmin(input);
  const getOrderItemById = (id) => OrderService.getOrderItemById(id);
  const getQrCodeImageForOrderItem = (id) => OrderService.getQrCodeImageForOrderItem(id);

  const getQrCodeImageForOrderItemGroup = (id) => OrderService.getQrCodeImageForOrderItemGroup(id);

  const createOrderShoppingCart = (input) => {
    if (Array.isArray(input.productDetailIds) && input.productDetailIds.length === 0) {
      delete input.productDetailIds;
    }

    if ('paymentMethodId' in input && !input.paymentMethodId) {
      delete input.paymentMethodId;
    }

    return OrderService.createOrderShoppingCart(input);
  };

  const createOrderBuyItNow = (input) => OrderService.createOrderBuyItNow(input);

  const completeOrderPurchase = (input) => OrderService.completeOrderPurchase(input);

  const completeOrderPurchaseWidget = (input) => OrderService.completeOrderPurchaseWidget(input);

  const getSellerOrderItemGroups = (variables) => {
    const serviceVariables = buildQueryVariables(variables);
    return OrderService.getSellerOrderItemGroups(serviceVariables);
  };
  const getSellerOrderItems = (variables) => {
    const serviceVariables = buildQueryVariables(variables);
    return OrderService.getSellerOrderItems(serviceVariables);
  };

  const getPendingOrders = (variables) => {
    const serviceVariables = buildQueryVariables(variables);
    return OrderService.getPendingOrders(serviceVariables);
  };

  const approvePendingOrder = (id) => OrderService.approvePendingOrder(id);

  const denyPendingOrder = (id, variables) => OrderService.denyPendingOrder(id, variables);

  const getOrderItemGroups = (params = {}) => OrderItemGroupService.getOrderItemGroups(params);

  const getOrderItemGroupById = (id) => OrderItemGroupService.getOrderItemGroupById(id);

  const updateStatusOfOrderItemGroup = (id, variables) =>
    OrderItemGroupService.updateStatus(id, variables);

  const updateStatusOfCashPaymentForOrder = (id, variables) =>
    OrderService.updateStatusOfCashPaymentForOrder(id, variables);

  const calculateCostAndDate = (variables, abortSignal) =>
    OrderService.calculateCostAndDate(variables, abortSignal);

  const getTrackingHistoryByOrderId = (id) =>
    OrderService.getTrackingHistoryByOrderId(id?.replace('#', ''));

  const getOrderItemStatuses = (variables) => OrderItemStatusService.getStatuses(variables);
  const getOrderItemStatusById = (id) => OrderItemStatusService.getStatusById(id);
  const createOrderItemStatus = (variables) => OrderItemStatusService.createStatus(variables);
  const updateOrderItemStatus = (id, variables) =>
    OrderItemStatusService.updateStatus(id, variables);
  const deleteOrderItemStatus = (id) => OrderItemStatusService.deleteStatus(id);

  const updateStatusOfOrderItem = (id, variables) => OrderItemService.updateStatus(id, variables);

  return {
    getOrders: getOrders,
    getOrdersByAdmin: getOrdersByAdmin,
    getOrderById: getOrderById,
    getOrderItems: getOrderItems,
    getOrderItemsByAdmin: getOrderItemsByAdmin,
    getOrderItemById: getOrderItemById,
    getQrCodeImageForOrderItemGroup: getQrCodeImageForOrderItemGroup,
    getQrCodeImageForOrderItem: getQrCodeImageForOrderItem,
    createOrderShoppingCart: createOrderShoppingCart,
    createOrderBuyItNow: createOrderBuyItNow,
    completeOrderPurchase: completeOrderPurchase,
    completeOrderPurchaseWidget: completeOrderPurchaseWidget,
    getSellerOrderItemGroups: getSellerOrderItemGroups,
    getSellerOrderItems: getSellerOrderItems,
    getPendingOrders: getPendingOrders,
    approvePendingOrder: approvePendingOrder,
    denyPendingOrder: denyPendingOrder,
    getOrderItemGroups: getOrderItemGroups,
    getOrderItemGroupById: getOrderItemGroupById,
    updateStatusOfOrderItemGroup: updateStatusOfOrderItemGroup,
    updateStatusOfCashPaymentForOrder: updateStatusOfCashPaymentForOrder,
    calculateCostAndDate: calculateCostAndDate,
    getTrackingHistoryByOrderId: getTrackingHistoryByOrderId,
    getOrderItemStatuses: getOrderItemStatuses,
    getOrderItemStatusById: getOrderItemStatusById,
    createOrderItemStatus: createOrderItemStatus,
    updateOrderItemStatus: updateOrderItemStatus,
    deleteOrderItemStatus: deleteOrderItemStatus,
    updateStatusOfOrderItem: updateStatusOfOrderItem,
  };
}
